module.exports = __webpack_public_path__ + "img/1982.e2ad227e.png";